import { render, staticRenderFns } from "./sp-region.vue?vue&type=template&id=a38d81ec&scoped=true"
import script from "./sp-region.vue?vue&type=script&lang=js"
export * from "./sp-region.vue?vue&type=script&lang=js"
import style0 from "./sp-region.vue?vue&type=style&index=0&id=a38d81ec&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38d81ec",
  null
  
)

export default component.exports